import { SVGProps } from 'react';

const ThumbScaleMediumKindUpDownReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_288_32)">
            <path
                d="M5 15V6.5M19 9V17.6017M19 9H18.5M19 9H21.5644C22.3573 9 23 9.6268 23 10.4V15.3C23 16.0732 22.3573 16.7 21.5644 16.7H19.8774C19.5938 16.7 19.3367 16.8629 19.2215 17.1157L19 17.6017M19 17.6017L16.6954 22.6583C16.6008 22.8661 16.3895 23 16.1563 23C15.1788 23 14.3863 22.2272 14.3863 21.2739V19.8C14.3863 19.4134 14.0649 19.1 13.6685 19.1H10.5M1 8.7V13.6C1 14.3732 1.64275 15 2.43562 15H12.0731C13.136 15 14.0399 14.2438 14.2015 13.2193L14.9745 8.31932C15.1752 7.04723 14.1659 5.9 12.8461 5.9H10.3315C9.93507 5.9 9.6137 5.5866 9.6137 5.2V2.72609C9.6137 1.7728 8.82124 1 7.8437 1C7.61054 1 7.39925 1.13391 7.30455 1.34169L4.7785 6.8843C4.66329 7.13709 4.40623 7.3 4.12256 7.3H2.43562C1.64275 7.3 1 7.9268 1 8.7Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_288_32">
                <rect width={24} height={24} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default ThumbScaleMediumKindUpDownReducedTrue;
